'use strict';
const angular = require('angular');

const uiRouter = require('angular-ui-router');

import routes from './home.routes';

export class HomeComponent {

  constructor(Auth, DynamicPageService, Config) {
    'ngInject';

    this.DynamicPageService = DynamicPageService;
    this.home = [];
    this.baseContainerClass = Config.getPlatformConfig().getBaseContainerClass();

    this.count = 0;

    Auth.getCurrentUser(user => {
      user.role.forEach(role => {
        DynamicPageService.getByName({name: role + '-home'}, page => {
          this.count++;
          let html = this.convertShortcode(page.data);
          this.home.push({
            role: role,
            page: html
          });
          if (!this.primaryHome) {
            this.primaryHome = html;
          }
        }, err => {
          this.pageNotFound = true;
        });
      });
    });
  }

  convertShortcode(html) {
    return html.replace(/\[/g,"<").replace(/\]/g,">");
  }
  
}

export default angular.module('conduuApp.homeView', [uiRouter])
  .config(routes)
  .component('home', {
    template: require('./home.html'),
    controller: HomeComponent,
    controllerAs: 'ctrl'
  })
  .name;



// WEBPACK FOOTER //
// ./client/app/home/home.component.js